module.exports = __webpack_public_path__ + "img/help21.2742f9be.png";